import {
  AuthorizationFailedReason,
  IncidentType
} from "@moderrotech/servers-communication-library/src/types";

export const es = {
  topics: {
    headerTitle: "Temas",
    search: "Búsqueda",
    noTopics: "No se encontraron temas",
    notFound: "No se encontraron temas que coincidan con el patrón",
    schedule: {
      closed: "Estamos cerrados"
    },
    customerInfoForm: {
      title: "Antes de comenzar su videollamada...",
      description:
        "Antes de utilizar la video banca para solicitar su préstamo, por favor, complete el formulario",
      optional: "Opcional",
      buttons: {
        cancel: "Cancelar",
        submit: "Iniciar videollamada"
      },
      agreement:
        'Al hacer clic en "Iniciar videollamada", aceptas nuestros Términos de servicio.'
    }
  },
  call: {
    calling: "Vocación...",
    joining: "Unirse a la llamada",
    transferring: "Transferir la llamada",
    aspectRatio: "Zoom",
    cancel: "Cancelar llamada",
    end: "Finalizar llamada",
    share: "Llamada multipartita",
    document: "Documento",
    actions: "Comportamiento",
    closeActions: "Cancelar",
    mute: "Mudo",
    unmute: "No silenciar",
    textMessage: "Mensaje de texto",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return `Eres el ${isPositionAvailable ? `#${position} ` : ""}en la cola`;
    },
    ticket: "Boleto",
    camera: {
      enable: "Habilitar cámara",
      disable: "Deshabilitar cámara"
    },
    hangupRequest: {
      title: "Estas seguro",
      body: "¿De verdad quieres desconectar?",
      yes: "si, colgar",
      no: "No, quédate en la llamada"
    },
    downloadFileRequest: {
      title: "El agente ha compartido un archivo con usted.",
      yes: "Descargar",
      no: "Descartar"
    },
    openUrlRequest: {
      title: "Abrir URL",
      body: "El experto quiere abrir una URL en una nueva pestaña",
      yes: "Abrir URL",
      no: "Cancelar"
    },
    lowPerformanceNotification: {
      title:
        "Parece que el dispositivo tiene un rendimiento bajo. Por favor, no utilice la cámara para evitar que la aplicación se bloquee",
      gotIt: "Entiendo"
    },
    signaturePad: {
      submit: "Entregar",
      clear: "Limpiar",
      cancel: "Cancelar"
    },
    paintover: {
      submit: "Entregar",
      clear: "Limpiar",
      cancel: "Cancelar"
    },
    textMessageForm: {
      placeholder: "Mensaje"
    },
    recordTranslator: {
      transcribing: "Habla por favor"
    },
    cameraSnapshot: {
      title: "Instantánea de la cámara"
    },
    mediaInputsAccessNote: {
      title: "Permita el acceso al micrófono y a la cámara.",
      description:
        "Busque una pequeña ventana emergente cerca de la barra de direcciones de su navegador."
    },
    animatedCharacter: {
      listening: {
        title: "El agente está escuchando",
        description: "Ya puede hablar. Diga su pregunta o solicitud."
      },
      thinking: {
        title: "El agente está pensando",
        description: "Por favor, espere mientras el agente busca una respuesta."
      }
    },
    success: {
      document: "El documento ha sido enviado con éxito.",
      feedback: "Se ha enviado un comentario.",
      textMessage: "El mensaje de texto ha sido enviado",
      signaturePad: "La firma ha sido enviada.",
      paintover: "La imagen ha sido enviada.",
      textCopy: "El texto ha sido copiado al portapapeles.",
      imageCopy: "La imagen ha sido copiada al portapapeles.",
      callSharing: "El enlace ha sido copiado al portapapeles."
    },
    error: {
      base: "Algo salió mal. Por favor recarga la página",
      mediaInputsAccess:
        "No puedo acceder al micrófono y/o a la cámara. Por favor, habilítelos en la configuración.",
      join: "No puedo unirme a la llamada",
      document: "No se puede enviar el documento",
      noExperts: "No hay expertos disponibles",
      noTopic: "El tema ya no está disponible",
      queueSuspended:
        "Cola suspendida<br>No podemos atender nuevas llamadas en este momento. Inténtelo de nuevo más tarde.",
      queueOverloaded:
        "Cola sobrecargada<br>Estamos experimentando un gran volumen de llamadas. Inténtelo de nuevo más tarde.",
      timeout: "Esperando a un experto demasiado tiempo",
      documentSize: "El documento es demasiado grande.",
      feedback: "Algo salió mal",
      noRoom: "La cita ha expirado o fue cancelada",
      textMessage: "El mensaje de texto no se puede enviar",
      signaturePad: "No se puede enviar la firma.",
      paintover: "El error al enviar la imagen.",
      textCopy: "No se puede copiar texto",
      imageCopy: "No se puede copiar la imagen",
      callSharing: "No se puede compartir enlace",
      recordTranslation: {
        play: "No se puede reproducir el audio de traducción",
        streamGetting: "No se puede obtener la transmisión de audio",
        transcription: "No se puede transcribir el registro",
        translation: "No se puede traducir el registro",
        unsupportedLanguage:
          "Seleccionado no compatible con SU idioma de traducción de audio. Pero el audio del experto se puede traducir a este idioma."
      },
      geolocation: "No puedo obtener geolocalización",
      cameraSnapshot: "No se puede tomar una instantánea de la cámara"
    },
    onHold: {
      title: "En espera.",
      description: "El agente se pondrá en contacto con usted en breve."
    },
    remoteActionRequest: {
      shareFile: {
        title:
          "El experto quiere compartir un archivo desde su dispositivo. ¿Permitir?",
        yes: "Sí",
        no: "No"
      },
      screenSharing: {
        title: "El experto quiere ver tu pantalla. ¿Permitir?",
        yes: "Sí",
        no: "No"
      }
    },
    settings: {
      title: "Ajustes",
      labels: {
        camera: "Cámara",
        microphone: "Micrófono"
      }
    }
  },
  thank: {
    toTopics: "Regresar a la página principal",
    redirect: "A la cita"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "Caducado."
          : "No hay expertos disponibles para responder a su llamada.";
      },
      body:
        "Puede dejar un mensaje a sus agentes para que se comuniquen con usted tan pronto como estén disponibles.",
      yes: "Crear un billete",
      no: "No, gracias"
    },
    form: {
      labels: {
        phone: "Teléfono",
        email: "Correo electrónico",
        message: "Mensaje"
      },
      buttons: {
        cancel: "Cancelar",
        submit: "Enviar un mensaje"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "De:",
          validation: {
            label: "correo electrónico"
          }
        },
        message: {
          label: "mensaje",
          placeholder: "Mensaje",
          validation: {
            label: "mensaje"
          }
        }
      },
      buttons: {
        submit: "Enviar",
        cancel: "Cancelar",
        open: "Agregar mensaje de comentarios..."
      },
      notifications: {
        success: "Se ha enviado el informe de error."
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "El Agente hablará contigo en un momento."
          : "Servicio no disponible temporalmente";
      },
      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "Estamos a punto de restaurar su conexión."
          : "Se ha perdido la conexión. Reconectando...";
      },
      code: "código: 503"
    },
    login: {
      credentials: "Nombre de usuario o contraseña incorrectos",
      default: "Algo salió mal"
    },
    unpublished: {
      title: "La aplicación no existe.",
      description:
        "Es posible que se haya dejado de publicar temporalmente o se haya eliminado de forma permanente.",
      code: "código: 404"
    },
    authorization: {
      title: "Acceso prohibido",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "La aplicación no está disponible en su país o región.",
          [AuthorizationFailedReason.noLicense]: "Sin licencia asignada.",
          [AuthorizationFailedReason.remStopped]: "Servicio No Disponible.",
          [AuthorizationFailedReason.noPtpcResponse]:
            "No hay respuesta del servidor."
        }[reason];
      },
      code: "código: 403"
    },
    network: {
      title: "Por favor asegúrese de tener acceso a Internet"
    }
  },
  validation: {
    phone: "El campo {field} debe ser un número de teléfono válido",
    dni: "ID incorrecta, formato no válido",
    nie: "ID incorrecta, formato no válido"
  }
};
